import React from 'react';
import { TickerResult } from '../../services/GameApiService';
import './ResultsTicker.css';

interface ResultsTickerProps {
  results: TickerResult[];
}

const ResultsTicker: React.FC<ResultsTickerProps> = ({ results }) => {
  // If no results, don't render
  if (!results || results.length === 0) {
    return null;
  }
  
  // Duplicate results 3x for seamless infinite loop
  const loopedResults = [...results, ...results, ...results];
  
  return (
    <div className="results-ticker">
      <div className="ticker-track">
        {loopedResults.map((result, idx) => (
          <div 
            key={`${result.wallet}-${result.timestamp}-${idx}`}
            className={`ticker-item ${result.won ? 'win' : 'bust'}`}
          >
            <span className="ticker-wallet">{result.wallet}</span>
            {result.won ? (
              <span className="ticker-result">WON {result.multiplier}x</span>
            ) : (
              <span className="ticker-result">BUST {result.multiplier}x</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ResultsTicker;

